"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[80],{

/***/ 49848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ passwordEncrypt; }
/* harmony export */ });
/* unused harmony export passwordDecrypt */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76679);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64155);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75312);






var passWordKey = {
  dev: {
    key: '8e8dex21a70d1u0891539b787009b04t'
  },
  test: {
    key: '8e8dex21a70d1u0891539b787009b04t'
  },
  sit: {
    key: '8e8dex21a70d1u0891539b787009b04t'
  },
  prod: {
    key: 'k91v3EtHSAwaGN3oy3u9abkgaOEFDF0W'
  }
};
var _getEnvironment = (0,_environment__WEBPACK_IMPORTED_MODULE_4__/* .getEnvironment */ .z)(),
  siteEnv = _getEnvironment.siteEnv,
  nodeEnv = _getEnvironment.nodeEnv;
var shopifyConfiguration = nodeEnv === 'dev' ? 'dev' : siteEnv;
var key = passWordKey[shopifyConfiguration].key;
// 密码加密
var passwordEncrypt = function passwordEncrypt(data) {
  var encryptKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : key;
  try {
    var _key = crypto_js__WEBPACK_IMPORTED_MODULE_3___default().enc.Utf8.parse(encryptKey);
    var encryptedData = crypto_js__WEBPACK_IMPORTED_MODULE_3___default().AES.encrypt(data, _key, {
      mode: (crypto_js__WEBPACK_IMPORTED_MODULE_3___default().mode).ECB,
      padding: (crypto_js__WEBPACK_IMPORTED_MODULE_3___default().pad).Pkcs7
    }).toString();
    return encryptedData;
  } catch (_unused) {
    throw new Error('passwordEncrypt error!');
  }
};

// 密码解密
var passwordDecrypt = function passwordDecrypt(data) {
  var encryptKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : key;
  try {
    var _key2 = crypto_js__WEBPACK_IMPORTED_MODULE_3___default().enc.Utf8.parse(encryptKey);
    var bytes = crypto_js__WEBPACK_IMPORTED_MODULE_3___default().AES.decrypt(data, _key2, {
      mode: (crypto_js__WEBPACK_IMPORTED_MODULE_3___default().mode).ECB,
      padding: (crypto_js__WEBPACK_IMPORTED_MODULE_3___default().pad).Pkcs7
    });
    var decryptedData = crypto_js__WEBPACK_IMPORTED_MODULE_3___default().enc.Utf8.stringify(bytes).toString();
    return decryptedData;
  } catch (_unused2) {
    throw new Error('passwordDecrypt error!');
  }
};
window[_definitions__WEBPACK_IMPORTED_MODULE_5__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_5__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  passwordEncrypt: passwordEncrypt,
  passwordDecrypt: passwordDecrypt
});


/***/ }),

/***/ 13931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   mr: function() { return /* binding */ formatTime; },
/* harmony export */   s8: function() { return /* binding */ isBeijingTimeInRange; }
/* harmony export */ });
/* unused harmony export countdown */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81597);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69746);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27557);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12197);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96600);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(64155);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }





















dayjs__WEBPACK_IMPORTED_MODULE_15___default().locale('en');
dayjs__WEBPACK_IMPORTED_MODULE_15___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_19___default()));
dayjs__WEBPACK_IMPORTED_MODULE_15___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_18___default()));
dayjs__WEBPACK_IMPORTED_MODULE_15___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_16___default()));
dayjs__WEBPACK_IMPORTED_MODULE_15___default().extend((dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_17___default()));
var formatTime = function formatTime(timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'America/New_York';
  try {
    if (!timestamp && timestamp !== 0) {
      return '';
    }
    return dayjs__WEBPACK_IMPORTED_MODULE_15___default()(Number(timestamp)).tz(timezone).format(format);
  } catch (_unused) {
    return '';
  }
};
var countdown = function countdown(_ref) {
  var endTimestamp = _ref.endTimestamp,
    callback = _ref.callback,
    _ref$interval = _ref.interval,
    intervalMs = _ref$interval === void 0 ? 1000 : _ref$interval,
    _ref$delayMs = _ref.delayMs,
    delayMs = _ref$delayMs === void 0 ? 0 : _ref$delayMs;
  // eslint-disable-next-line prefer-const
  var intervalId;
  var task = function task() {
    var diff = endTimestamp - dayjs().valueOf();
    callback(diff);
    if (diff <= 0) {
      clearInterval(intervalId);
    }
  };
  if (delayMs) {
    setTimeout(function () {
      task();
      intervalId = setInterval(task, intervalMs);
    }, delayMs);
  } else {
    intervalId = setInterval(task, intervalMs);
  }
  return intervalId;
};

/**
 * 判断当前北京时间是否在指定时间区间内
 * @param {string} rangeStr - 时间区间字符串，格式 "YYYY/MM/DD HH:mm:ss-YYYY/MM/DD HH:mm:ss"
 * @returns {boolean} 是否在区间内
 */
var isBeijingTimeInRange = function isBeijingTimeInRange(rangeString) {
  var beijingTZ = 'Asia/Shanghai';
  var INPUT_FORMAT = 'YYYY/MM/DD HH:mm:ss';
  // 校验格式
  var REG = /^(\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2})-(\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2})$/;
  var match = rangeString.match(REG);
  if (!match) {
    console.error('Invalid time range format. Expected "YYYY/MM/DD HH:mm:ss-YYYY/MM/DD HH:mm:ss"');
    return false;
  }
  var _match = _slicedToArray(match, 3),
    startString = _match[1],
    endString = _match[2];

  // 解析北京时间
  var start = dayjs__WEBPACK_IMPORTED_MODULE_15___default().tz(startString, INPUT_FORMAT, beijingTZ);
  var end = dayjs__WEBPACK_IMPORTED_MODULE_15___default().tz(endString, INPUT_FORMAT, beijingTZ);
  var now = dayjs__WEBPACK_IMPORTED_MODULE_15___default()().tz(beijingTZ);

  // 校验时间有效性
  if (!start.isValid() || !end.isValid()) {
    console.error('Invalid time string');
    return false;
  }

  // 校验起止顺序
  if (start.isAfter(end)) {
    console.error('Start time cannot be later than end time');
    return false;
  }
  return now.isAfter(start) && now.isBefore(end);
};
window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  dayjs: (dayjs__WEBPACK_IMPORTED_MODULE_15___default())
});
/* harmony default export */ __webpack_exports__.ZP = ((dayjs__WEBPACK_IMPORTED_MODULE_15___default()));

/***/ }),

/***/ 75312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ getEnvironment; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0__);

var getEnvironment = function getEnvironment() {
  var siteEnvironment = (window.__settingEnv || 'prod').trim().toLowerCase();
  return {
    siteEnv: siteEnvironment,
    nodeEnv: window.__localEnv || ''
  };
};

/***/ }),

/***/ 81228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(64155);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



















function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    _defineProperty(this, "addListener", this.on);
    this._events = Object.create(null);
    this._emitNullQueue = Object.create(null);
  }
  return _createClass(EventEmitter, [{
    key: "eventNames",
    value: function eventNames() {
      return Object.keys(this._events);
    }
  }, {
    key: "setMaxListeners",
    value: function setMaxListeners(n) {
      this._count = n;
    }
  }, {
    key: "getMaxListeners",
    value: function getMaxListeners() {
      var _this$_count;
      return (_this$_count = this._count) !== null && _this$_count !== void 0 ? _this$_count : EventEmitter.defaultMaxListeners;
    }

    /**
     * 订阅
     * @param {*} type
     * @param {*} callback
     * @param {*} flag 决定 event 添加位置
     * @param {*} emitByCache 如果emit有数据，直接触发
     */
  }, {
    key: "on",
    value: function on(type, callback) {
      var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var emitByCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!this._events) {
        this._events = Object.create(null);
      }
      if (this._events[type]) {
        if (pos) {
          this._events[type].unshift(callback);
        } else {
          this._events[type].push(callback);
        }
      } else {
        this._events[type] = [callback];
      }
      if (emitByCache && this._emitNullQueue[type]) {
        var arguments_ = this._emitNullQueue[type];
        callback.call.apply(callback, [this].concat(_toConsumableArray(arguments_)));
      }
      if (this._events[type].length >= this.getMaxListeners()) {
        console.warn('EventEmitter 监听超过限制');
      }
    }
  }, {
    key: "once",
    value: function once(type, callback, flag) {
      // 新函数在调用后直接删除
      function wrap() {
        callback.apply(void 0, arguments);
        this.removeListener(type, wrap);
      }
      // 自定义属性，removeListener 方便感知
      wrap.listen = callback;
      this.on(type, wrap, flag);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(type) {
      if (type) {
        delete this._events[type];
        delete this._emitNullQueue[type];
      } else {
        this._events = Object.create(null);
        this._emitNullQueue = Object.create(null);
      }
    }
  }, {
    key: "removeListener",
    value: function removeListener(type, callback) {
      if (!this._events[type]) {
        return;
      }

      /**
       * 如果没有回调，全部清空
       */
      if (!callback) {
        this._events[type] = [];
        return;
      }
      this._events[type] = this._events[type].filter(function (listener) {
        return callback !== listener && callback !== listener.listen;
      });
      if (this._events[type].length === 0) {
        delete this._events[type];
      }
    }

    /**
     * 移除事件监听器（removeListener 的别名）
     * @param {string} type - 事件类型
     * @param {Function} callback - 回调函数
     */
  }, {
    key: "off",
    value: function off(type, callback) {
      this.removeListener(type, callback);
    }

    /**
     * 这里为异步，取队列
     * @param {*} type
     * @param  {...any} arguments_
     * @returns
     */
  }, {
    key: "emit",
    value: function emit(type) {
      for (var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        arguments_[_key - 1] = arguments[_key];
      }
      if (!this._events[type]) {
        this._emitNullQueue[type] = [].concat(arguments_);
        return;
      }
      var _iterator = _createForOfIteratorHelper(this._events[type] || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;
          listener.call.apply(listener, [this].concat(arguments_));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this._emitNullQueue[type] = [].concat(arguments_);
    }
  }, {
    key: "listeners",
    value: function listeners(type) {
      return this._events[type];
    }
  }, {
    key: "prependListener",
    value: function prependListener(type, callback) {
      this.on(type, callback, true);
    }
  }, {
    key: "prependOnceListener",
    value: function prependOnceListener(type, callback) {
      this.once(type, callback, true);
    }
  }]);
}(); // eslint-disable-next-line unicorn/prefer-event-target
_defineProperty(EventEmitter, "defaultMaxListeners", 100);
var eventEmitter = new EventEmitter();
window[_definitions__WEBPACK_IMPORTED_MODULE_19__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_19__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  eventEmitter: eventEmitter
});
/* harmony default export */ __webpack_exports__.Z = (eventEmitter);

/***/ }),

/***/ 25675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S1: function() { return /* binding */ off; },
/* harmony export */   g4: function() { return /* binding */ offByContainer; },
/* harmony export */   on: function() { return /* binding */ on; }
/* harmony export */ });
/* unused harmony exports fire, onAsync */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81970);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86225);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78305);
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(84750);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var selector_set__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(92933);
/* harmony import */ var _misc__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(36792);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





















/**
 * https://github.com/dgraham/delegated-events/blob/master/delegated-events.js
 * 传送门
 */



var noop = function noop() {};

/**
 * 默认应用场景为冒泡应该足矣
 */
var BUBBLE = {
  capture: false
};
var bubbleEvents = new WeakMap();
var captureEvents = new WeakMap();
var propagationStopped = new WeakMap();
var immediatePropagationStopped = new WeakMap();
var currentTargets = new WeakMap();
var currentTargetDesc = Object.getOwnPropertyDescriptor(Event.prototype, 'currentTarget');
var lastClickTimeMap = new WeakMap();

// 真正的全局锁 Map，所有使用 lockScope: 'global' 的 onAsync 共享
var globalLocks = new Map();
function before(subject, verb, function_) {
  var source = subject[verb];
  subject[verb] = function () {
    function_.apply(subject, arguments);
    return source.apply(subject, arguments);
  };
  return subject;
}
function matches(selectors, target, reverse) {
  var queue = [];
  var node = target;
  do {
    if (node.nodeType !== 1) break;
    var _matches = selectors.matches(node);
    if (_matches.length > 0) {
      var matched = {
        node: node,
        observers: _matches
      };
      if (reverse) {
        queue.unshift(matched);
      } else {
        queue.push(matched);
      }
    }
  } while (node = node.parentElement);
  return queue;
}
function trackPropagation() {
  propagationStopped.set(this, true);
}
function trackImmediate() {
  propagationStopped.set(this, true);
  immediatePropagationStopped.set(this, true);
}
function getCurrentTarget() {
  return currentTargets.get(this) || null;
}
function defineCurrentTarget(event, getter) {
  if (!currentTargetDesc) return;
  Object.defineProperty(event, 'currentTarget', {
    configurable: true,
    enumerable: true,
    get: getter || currentTargetDesc.get
  });
}
function canDispatch(event) {
  try {
    event.eventPhase;
    return true;
  } catch (_unused) {
    return false;
  }
}
function dispatch(event) {
  if (!canDispatch(event)) return;
  var container = event.currentTarget;
  var eventsContainer = event.eventPhase === 1 ? captureEvents : bubbleEvents;
  var events = eventsContainer.get(container);
  var selectors = events[event.type];
  if (!selectors) return;
  var queue = matches(selectors, event.target, event.eventPhase === 1);
  if (queue.length === 0) return;
  before(event, 'stopPropagation', trackPropagation);
  before(event, 'stopImmediatePropagation', trackImmediate);
  defineCurrentTarget(event, getCurrentTarget);
  for (var index = 0, length1 = queue.length; index < length1; index++) {
    if (propagationStopped.get(event)) break;
    var matched = queue[index];
    currentTargets.set(event, matched.node);
    if (!('delegateTarget' in event)) {
      event.delegateTarget = matched.node;
    }
    for (var _index = 0, length2 = matched.observers.length; _index < length2; _index++) {
      if (immediatePropagationStopped.get(event)) break;
      matched.observers[_index].data.call(matched.node, event);
    }
  }
  currentTargets.delete(event);
  defineCurrentTarget(event);
}

/**
 * 统一双击（桌面端）和双触（移动端）事件
 */
function setupDoubleClick(container) {
  var lastTouchEnd = 0;
  var lastTouchTarget = null;
  var DOUBLE_DELAY = 300;
  if (_misc__WEBPACK_IMPORTED_MODULE_22__/* .isMobile */ .tq) {
    // 触摸点击（移动端）
    container.addEventListener('touchend', function (event) {
      if (event.touches.length > 0) return; // 多指时不算
      var now = Date.now();
      var target = event.target;
      if (lastTouchTarget === target && now - lastTouchEnd < DOUBLE_DELAY) {
        var doubleEvent = new CustomEvent('doubleclick', {
          bubbles: true,
          cancelable: true,
          detail: {
            event: event
          }
        });
        target.dispatchEvent(doubleEvent);
        lastTouchEnd = 0;
        lastTouchTarget = null;
      } else {
        lastTouchEnd = now;
        lastTouchTarget = target;
      }
    }, true);
  } else {
    // 鼠标点击（桌面端）
    container.addEventListener('click', function (event) {
      var now = Date.now();
      var last = lastClickTimeMap.get(event.target);
      if (last && now - last < DOUBLE_DELAY) {
        var doubleEvent = new CustomEvent('doubleclick', {
          bubbles: true,
          cancelable: true,
          detail: {
            event: event
          }
        });
        event.target.dispatchEvent(doubleEvent);
        lastClickTimeMap.delete(event.target);
      } else {
        lastClickTimeMap.set(event.target, now);
      }
    }, true);
  }
}
function on(name, selector, function_) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var container = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;
  options = Object.assign({}, BUBBLE, options);
  var capture = !!options.capture;
  var eventsContainer = capture ? captureEvents : bubbleEvents;
  if (!eventsContainer.has(container)) {
    eventsContainer.set(container, Object.create(null));
  }
  var events = eventsContainer.get(container);
  var selectors = events[name];
  if (_misc__WEBPACK_IMPORTED_MODULE_22__/* .isSafari */ .G6 && _misc__WEBPACK_IMPORTED_MODULE_22__/* .isMobile */ .tq) {
    var _iterator = _createForOfIteratorHelper(container.querySelectorAll(selector)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var current = _step.value;
        current.addEventListener(name, noop);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // 自动为 doubleclick 注册 click 代理监听
  if (name === 'doubleclick' && !events.__doubleclickSetup) {
    setupDoubleClick(container);
    events.__doubleclickSetup = true;
  }
  if (!selectors) {
    selectors = new selector_set__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z();
    events[name] = selectors;
    container.addEventListener(name, dispatch, options);
  }
  selectors.add(selector, function_);
}
function off(name, selector, function_) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var container = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;
  options = Object.assign({}, BUBBLE, options);
  var capture = !!options.capture;
  var eventsContainer = capture ? captureEvents : bubbleEvents;
  var events = eventsContainer.get(container);
  var selectors = events === null || events === void 0 ? void 0 : events[name];
  if (!selectors) return;
  selectors.remove(selector, function_);
  if (selectors.size > 0) return;
  delete events[name];
  if (_misc__WEBPACK_IMPORTED_MODULE_22__/* .isSafari */ .G6 && _misc__WEBPACK_IMPORTED_MODULE_22__/* .isMobile */ .tq) {
    var _iterator2 = _createForOfIteratorHelper(container.querySelectorAll(selector)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var current = _step2.value;
        current.removeEventListener(name, noop);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  container.removeEventListener(name, dispatch, options);
}

/**
 * 实际上 WeakMap 不需要关注 dom 被移除后还有内存泄露的问题
 * 但从数据结构上建议保持一致性，所有在有需要时，可以手动清空事件委托根容器的绑定
 * @param {*} container
 */
function offByContainer(container) {
  var removeEvents = function removeEvents(events, capture) {
    if (!events) return;
    for (var name in events) {
      var selectors = events[name];
      if (!selectors || selectors.size === 0) continue;
      for (var _i = 0, _Object$values = Object.values(selectors.selectorObjects); _i < _Object$values.length; _i++) {
        var _Object$values$_i = _Object$values[_i],
          selector = _Object$values$_i.selector,
          function_ = _Object$values$_i.data;
        off(name, selector, function_, {
          capture: capture
        }, container);
      }
    }
  };
  removeEvents(captureEvents.get(container), true);
  removeEvents(bubbleEvents.get(container), false);
  captureEvents.delete(container);
  bubbleEvents.delete(container);
}
function fire(target, name, detail) {
  return target.dispatchEvent(new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail: detail
  }));
}

/**
 * 防止异步事件处理器重复执行的事件委托函数
 *
 * @description
 * 用于包装异步事件处理器，自动添加锁机制，防止快速点击导致重复执行。
 * 适用于需要异步操作的点击事件（如打开弹窗、发送请求等）。
 *
 * @param {string} name - 事件类型（如 'click', 'change'）
 * @param {string} selector - CSS 选择器
 * @param {Function} asyncHandler - 异步事件处理函数
 * @param {Object} options - 配置选项
 * @param {string} options.lockKey - 元素级锁的键名，默认 '_isProcessing'
 * @param {boolean} options.addProcessingClass - 是否添加 'is-processing' class，默认 true
 * @param {string} options.lockScope - 锁的作用域，'element' 或 'global'，默认 'element'
 * @param {string} options.globalLockKey - 全局锁的键名，默认 'default'（仅在 lockScope: 'global' 时有效）
 * @param {boolean} options.disableElement - 是否在处理期间禁用元素，默认 false
 * @param {boolean} options.capture - 是否使用捕获阶段，默认 false
 * @param {Function} options.onError - 错误处理函数，默认打印到 console.error
 * @param {HTMLElement} container - 事件委托的根容器，默认 document
 *
 * @example
 * // 基本用法
 * onAsync('click', '.my-button', async (event) => {
 *   await someAsyncOperation()
 * })
 *
 * @example
 * // 使用全局锁（所有使用相同 globalLockKey 的事件共享同一个锁）
 * onAsync('click', '.modal-trigger-1', async (event) => {
 *   await openModal1()
 * }, { lockScope: 'global', globalLockKey: 'modal' })
 *
 * onAsync('click', '.modal-trigger-2', async (event) => {
 *   await openModal2()
 * }, { lockScope: 'global', globalLockKey: 'modal' })
 * // 以上两个事件共享同一个全局锁，同一时间只能执行一个
 *
 * @example
 * // 禁用元素并添加视觉反馈
 * onAsync('click', '.submit-btn', async (event) => {
 *   await submitForm()
 * }, { disableElement: true, addProcessingClass: true })
 *
 * @example
 * // 自定义错误处理
 * onAsync('click', '.api-call-btn', async (event) => {
 *   await callApi()
 * }, {
 *   onError: (error) => {
 *     console.warn('API call failed:', error)
 *     showErrorToast(error.message)
 *   }
 * })
 *
 * @returns {void}
 *
 * @side effects
 * - 在异步操作期间，会在元素上设置锁标记（element[lockKey] = true）或全局锁
 * - 可选：添加 'is-processing' class 到元素
 * - 可选：设置元素的 disabled 属性
 * - 异步操作完成后，自动清理所有状态
 * - 错误会被捕获、记录并重新抛出
 */
function onAsync(name, selector, asyncHandler) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var container = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;
  var _options$lockKey = options.lockKey,
    lockKey = _options$lockKey === void 0 ? '_isProcessing' : _options$lockKey,
    _options$addProcessin = options.addProcessingClass,
    addProcessingClass = _options$addProcessin === void 0 ? true : _options$addProcessin,
    _options$lockScope = options.lockScope,
    lockScope = _options$lockScope === void 0 ? 'element' : _options$lockScope,
    _options$globalLockKe = options.globalLockKey,
    globalLockKey = _options$globalLockKe === void 0 ? 'default' : _options$globalLockKe,
    _options$disableEleme = options.disableElement,
    disableElement = _options$disableEleme === void 0 ? false : _options$disableEleme,
    _options$capture = options.capture,
    capture = _options$capture === void 0 ? false : _options$capture,
    _options$onError = options.onError,
    onError = _options$onError === void 0 ? function (error) {
      return console.error('Async event handler error:', error);
    } : _options$onError;

  // 包装后的处理器
  var wrappedHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var element,
        _len,
        restArguments,
        _key,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            element = event.currentTarget; // 检查锁
            if (!(lockScope === 'global')) {
              _context.n = 2;
              break;
            }
            if (!globalLocks.get(globalLockKey)) {
              _context.n = 1;
              break;
            }
            return _context.a(2, undefined);
          case 1:
            globalLocks.set(globalLockKey, true);
            _context.n = 4;
            break;
          case 2:
            if (!element[lockKey]) {
              _context.n = 3;
              break;
            }
            return _context.a(2, undefined);
          case 3:
            element[lockKey] = true;
          case 4:
            // 添加视觉反馈
            if (addProcessingClass) {
              element.classList.add('is-processing');
            }
            if (disableElement) {
              element.setAttribute('disabled', 'disabled');
            }
            _context.p = 5;
            for (_len = _args.length, restArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              restArguments[_key - 1] = _args[_key];
            }
            _context.n = 6;
            return asyncHandler.call.apply(asyncHandler, [this, event].concat(restArguments));
          case 6:
            return _context.a(2, _context.v);
          case 7:
            _context.p = 7;
            _t = _context.v;
            // 调用自定义错误处理器
            onError(_t);
            throw _t;
          case 8:
            _context.p = 8;
            // 释放锁
            if (lockScope === 'global') {
              globalLocks.delete(globalLockKey);
            } else {
              element[lockKey] = false;
            }

            // 移除视觉反馈
            if (addProcessingClass) {
              element.classList.remove('is-processing');
            }
            if (disableElement) {
              element.removeAttribute('disabled');
            }
            return _context.f(8);
          case 9:
            return _context.a(2);
        }
      }, _callee, this, [[5, 7, 8, 9]]);
    }));
    return function wrappedHandler(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // 使用现有的 on 函数注册事件
  on(name, selector, wrappedHandler, {
    capture: capture
  }, container);
}

/***/ }),

/***/ 37750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ unescapeHtmlAttribute; },
/* harmony export */   z: function() { return /* binding */ escapeHtmlAttribute; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86028);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26956);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_2__);



function escapeHtmlAttribute(s) {
  return s ? String(s).replaceAll('&', '&amp;').replaceAll('"', '&quot;').replaceAll("'", '&#39;').replaceAll('<', '&lt;').replaceAll('>', '&gt;') : s;
}
function unescapeHtmlAttribute(string_) {
  if (!string_) return string_;
  return String(string_).replaceAll('&amp;', '&') // 必须最后处理
  .replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('&quot;', '"').replaceAll('&#39;', "'");
}

/***/ }),

/***/ 85097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_parse_float_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45108);
/* harmony import */ var core_js_modules_es_number_parse_float_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_float_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86225);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44567);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(33373);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(84750);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47134);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(31955);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }























// 记录已触发的埋点节点


var observerOptions = {
  threshold: [0.3]
};

/**
 * 检查元素是否真正可见
 * @param {Element} element - 要检查的元素
 * @returns {boolean} 元素是否可见
 */
var isElementVisible = function isElementVisible(element) {
  if (!element || !element.ownerDocument) {
    return false;
  }
  var style = window.getComputedStyle(element);
  if (style.display === 'none' || style.visibility === 'hidden' || Number.parseFloat(style.opacity) === 0) {
    return false;
  }
  return true;
};

// 批量曝光：batch为true，callback参数为数组
var impressionTracking = function impressionTracking(selector, callback) {
  var repeat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var batch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  // 参数验证
  if (!selector) {
    console.warn('impressionTracking: selector is required');
    return undefined;
  }
  if (typeof callback !== 'function') {
    console.warn('impressionTracking: callback must be a function');
    return undefined;
  }

  // 为每个实例创建独立的 WeakMap
  var trackingMap = new WeakMap();
  var trackedMap = new WeakMap();

  // 批量曝光
  var batchImpressionTimer;
  var targetSet = new Set(); // 使用 Set 避免重复元素

  var batchImpression = function batchImpression(target) {
    clearTimeout(batchImpressionTimer);
    targetSet.add(target); // 使用 Set 自动去重
    batchImpressionTimer = setTimeout(function () {
      var targetList = _toConsumableArray(targetSet);
      if (targetList.length > 0) {
        try {
          callback(targetList);
        } catch (error) {
          console.error('impressionTracking callback error:', error);
        }
      }
      targetSet.clear();
    }, delay);
  };
  var handleIntersection = function handleIntersection(entries, observer) {
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      var _loop = function _loop() {
          var entry = _step.value;
          var target = entry.target,
            isIntersecting = entry.isIntersecting;
          if (!isIntersecting) {
            return 0; // continue
          }

          // 检查元素是否真正可见
          if (!isElementVisible(target)) {
            return 0; // continue
          }

          // 不允许重复触发&已触发过 跳过当前元素
          if (!repeat && trackedMap.get(target)) {
            return 0; // continue
            // 修复：使用 continue 而不是 break
          }
          clearTimeout(trackingMap.get(target));
          var timeoutId = setTimeout(function () {
            trackedMap.set(target, true);
            if (batch) {
              batchImpression(target);
            } else {
              try {
                callback(target);
              } catch (error) {
                console.error('impressionTracking callback error:', error);
              }
            }
          }, delay);
          trackingMap.set(target, timeoutId);
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var trackedElements = selector && typeof selector !== 'string' ? selector : document.querySelectorAll(selector);
  if (!trackedElements || trackedElements.length === 0) {
    console.warn('impressionTracking: no elements found for selector', selector);
    return undefined;
  }

  // 构建 IntersectionObserver 配置，支持自定义 root 和其他选项
  var observerConfig = _objectSpread(_objectSpread({}, observerOptions), options);

  // 使用节流而不是防抖，确保所有事件都被处理
  var throttledHandleIntersection = lodash_es__WEBPACK_IMPORTED_MODULE_23__/* ["default"].throttle */ .ZP.throttle(handleIntersection, 16,
  // 约 1 帧，提高响应速度
  {
    leading: true,
    trailing: true
  });
  var observer = new IntersectionObserver(throttledHandleIntersection, observerConfig);

  // 观察初始元素
  var _iterator2 = _createForOfIteratorHelper(trackedElements),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var element = _step2.value;
      observer.observe(element);
    }

    /**
     * 手动检查元素是否可见并触发追踪
     * @param {NodeList|Array<Element>} elements - 要检查的元素列表
     */
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var checkElements = function checkElements(elements) {
    if (!elements || elements.length === 0) {
      return;
    }
    var root = observerConfig.root || undefined;
    var rootRect = root ? root.getBoundingClientRect() : {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    };
    var visibleElements = [];
    var _iterator3 = _createForOfIteratorHelper(elements),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _element = _step3.value;
        if (!isElementVisible(_element)) {
          continue;
        }

        // 不允许重复触发&已触发过 跳过
        if (!repeat && trackedMap.get(_element)) {
          continue;
        }
        var rect = _element.getBoundingClientRect();
        var isVisible = rect.top < rootRect.bottom && rect.bottom > rootRect.top && rect.left < rootRect.right && rect.right > rootRect.left;
        if (isVisible) {
          visibleElements.push(_element);
        }
      }

      // 批量处理可见元素
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    if (visibleElements.length > 0) {
      if (batch) {
        var _iterator4 = _createForOfIteratorHelper(visibleElements),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var element = _step4.value;
            batchImpression(element);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        var _iterator5 = _createForOfIteratorHelper(visibleElements),
          _step5;
        try {
          var _loop2 = function _loop2() {
            var element = _step5.value;
            clearTimeout(trackingMap.get(element));
            var timeoutId = setTimeout(function () {
              trackedMap.set(element, true);
              try {
                callback(element);
              } catch (error) {
                console.error('impressionTracking callback error:', error);
              }
            }, delay);
            trackingMap.set(element, timeoutId);
          };
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  };

  // 返回 observer 实例和动态管理方法
  return {
    observer: observer,
    /**
     * 动态添加观察元素
     * @param {Element} element - 要观察的元素
     */
    observe: function observe(element) {
      if (element && element.nodeType === Node.ELEMENT_NODE) {
        observer.observe(element);
      }
    },
    /**
     * 移除观察元素
     * @param {Element} element - 要移除观察的元素
     */
    unobserve: function unobserve(element) {
      if (element) {
        observer.unobserve(element);
        clearTimeout(trackingMap.get(element));
        trackingMap.delete(element);
        trackedMap.delete(element);
        targetSet.delete(element);
      }
    },
    /**
     * 停止所有观察并清理资源
     */
    disconnect: function disconnect() {
      observer.disconnect();
      clearTimeout(batchImpressionTimer);
      // WeakMap 会自动清理，但我们可以清理 Set
      targetSet.clear();
    },
    /**
     * 重置追踪状态，允许重新追踪已追踪的元素
     */
    reset: function reset() {
      trackedMap.clear();
      targetSet.clear();
    },
    /**
     * 手动检查元素是否可见并触发追踪
     * @param {NodeList|Array<Element>} elements - 要检查的元素列表
     */
    checkElements: checkElements
  };
};
/* harmony default export */ __webpack_exports__.Z = (impressionTracking);

/***/ }),

/***/ 56908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   bH: function() { return /* binding */ matchIP; },
/* harmony export */   fj: function() { return /* binding */ getIsUsIp; }
/* harmony export */ });
/* unused harmony exports ipInfoApi, getIpCountryCode */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19650);






function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


// IP 归属地缓存 24 小时，与 Luvme 保持一致
var IP_INFO_CACHE_AGE = 24 * 60 * 60 * 1000;
var ipInfoApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var data,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          data = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _context.p = 1;
          _context.n = 2;
          return (0,_utils_request__WEBPACK_IMPORTED_MODULE_6__/* .heteRequest */ .xC)('/general/front/address/country/ipInfo', {
            data: data,
            retry: false,
            maxAge: IP_INFO_CACHE_AGE
          });
        case 2:
          return _context.a(2, _context.v);
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2, {
            traceId: _t.traceId,
            code: _t.code,
            message: _t.message,
            axiosStatus: 'error'
          });
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function ipInfoApi() {
    return _ref.apply(this, arguments);
  };
}();
var getIpCountryCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var result;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return ipInfoApi();
        case 1:
          result = _context2.v;
          if (!(!result || result.axiosStatus === 'error')) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, undefined);
        case 2:
          return _context2.a(2, result.countryCode);
      }
    }, _callee2);
  }));
  return function getIpCountryCode() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 是否是美区 IP
 * @returns {Promise<boolean|undefined>} 拿不到 IP 信息时返回 undefined
 */
var getIsUsIp = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var countryCode;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return getIpCountryCode();
        case 1:
          countryCode = _context3.v;
          return _context3.a(2, countryCode ? countryCode === 'US' : undefined);
      }
    }, _callee3);
  }));
  return function getIsUsIp() {
    return _ref3.apply(this, arguments);
  };
}();
var matchIP = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(code) {
    var _t2, _t3;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return getIpCountryCode();
        case 1:
          _t2 = _context4.v;
          _t3 = code;
          return _context4.a(2, _t2 === _t3);
      }
    }, _callee4);
  }));
  return function matchIP(_x) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ds: function() { return /* reexport safe */ lodash_es_debounce_js__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   Xy: function() { return /* reexport safe */ lodash_es_isEqual_js__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   xb: function() { return /* reexport safe */ lodash_es_isEmpty_js__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var lodash_es_cloneDeep_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89973);
/* harmony import */ var lodash_es_debounce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56356);
/* harmony import */ var lodash_es_intersection_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(666);
/* harmony import */ var lodash_es_isEmpty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29955);
/* harmony import */ var lodash_es_isEqual_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26338);
/* harmony import */ var lodash_es_maxBy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41983);
/* harmony import */ var lodash_es_throttle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64489);
/* harmony import */ var lodash_es_uniqueId_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63345);









/* harmony default export */ __webpack_exports__.ZP = ({
  cloneDeep: lodash_es_cloneDeep_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  debounce: lodash_es_debounce_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  intersection: lodash_es_intersection_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
  isEmpty: lodash_es_isEmpty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  isEqual: lodash_es_isEqual_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
  maxBy: lodash_es_maxBy_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
  throttle: lodash_es_throttle_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
  uniqueId: lodash_es_uniqueId_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
});

/***/ }),

/***/ 44981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ shouldSkipLoginPopup; }
/* harmony export */ });
/* unused harmony export SKIP_LOGIN_POPUP_SELECTOR */
/** 落在 `.login-register-button` 内、点击时不拉起登录弹窗的可交互元素 */
var SKIP_LOGIN_POPUP_SELECTOR = '[data-skip-login-popup]';

/**
 * @param {Event} event
 * @returns {boolean}
 */
var shouldSkipLoginPopup = function shouldSkipLoginPopup(event) {
  var _event$target;
  return Boolean((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest(SKIP_LOGIN_POPUP_SELECTOR));
};

/***/ }),

/***/ 33208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V2: function() { return /* binding */ markMemberCodePending; }
/* harmony export */ });
/* unused harmony exports getLoginCustomerInfo, getCachedMemberCode, syncMemberCode, ensureMemberCode, syncMemberCodeAfterLogin, clearMemberCode */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39574);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43908);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37666);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86651);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _api_personal_center__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16809);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38440);
/* harmony import */ var _utils_store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45837);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }














var MEMBER_CODE_STORAGE_KEY = 'MEMBER_CODE';
/** 登录成功标记：登录走整页 POST 跳转，只能在落地页再补拉会员编码 */
var MEMBER_CODE_PENDING_STORAGE_KEY = 'MEMBER_CODE_PENDING';
var pendingSync;

/**
 * 当前登录用户信息
 *
 * `userInfo` 由 `lib/snippets/common/index.liquid` 注入到 `DEFAULT_STORE_STATE`；
 * 游客的 `customerID` / `customerEmail` 为空串。
 */
var getLoginCustomerInfo = function getLoginCustomerInfo() {
  var _store$getState;
  var _ref = (_store$getState = store.getState('userInfo')) !== null && _store$getState !== void 0 ? _store$getState : {},
    _ref$customerID = _ref.customerID,
    customerID = _ref$customerID === void 0 ? '' : _ref$customerID,
    _ref$customerEmail = _ref.customerEmail,
    customerEmail = _ref$customerEmail === void 0 ? '' : _ref$customerEmail,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? '' : _ref$email;
  return {
    customerID: String(customerID !== null && customerID !== void 0 ? customerID : '').trim(),
    customerEmail: String(customerEmail || email || '').trim().toLowerCase()
  };
};
var normalizeIdentity = function normalizeIdentity() {
  var _ref3, _ref4;
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    customerId = _ref2.customerId,
    customerEmail = _ref2.customerEmail;
  var currentIdentity = getLoginCustomerInfo();
  return {
    customerId: String((_ref3 = customerId !== null && customerId !== void 0 ? customerId : currentIdentity.customerID) !== null && _ref3 !== void 0 ? _ref3 : '').trim(),
    customerEmail: String((_ref4 = customerEmail !== null && customerEmail !== void 0 ? customerEmail : currentIdentity.customerEmail) !== null && _ref4 !== void 0 ? _ref4 : '').trim().toLowerCase()
  };
};
var readMemberCodeCache = function readMemberCodeCache() {
  var cached = storage(MEMBER_CODE_STORAGE_KEY).get();
  return cached && _typeof(cached) === 'object' ? cached : {};
};

/**
 * 已缓存的会员编码
 *
 * 缓存与 customerId 绑定，切换账号（未及时清缓存）时不会复用上一个账号的编码。
 */
var getCachedMemberCode = function getCachedMemberCode() {
  var _getLoginCustomerInfo = getLoginCustomerInfo(),
    customerID = _getLoginCustomerInfo.customerID;
  var _readMemberCodeCache = readMemberCodeCache(),
    customerId = _readMemberCodeCache.customerId,
    memberCode = _readMemberCodeCache.memberCode;
  if (!customerID || customerId !== customerID) {
    return '';
  }
  return String(memberCode !== null && memberCode !== void 0 ? memberCode : '').trim();
};

/**
 * 拉取并缓存会员编码（CRM `memberCode`）
 *
 * - 未登录或拿不到 customer 时清理缓存
 * - 同一 customer 的并发调用复用同一个请求
 */
var syncMemberCode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(identity) {
    var _pendingSync;
    var _normalizeIdentity, customerId, customerEmail, job;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _normalizeIdentity = normalizeIdentity(identity), customerId = _normalizeIdentity.customerId, customerEmail = _normalizeIdentity.customerEmail;
          if (customerId) {
            _context2.n = 1;
            break;
          }
          clearMemberCode();
          return _context2.a(2, '');
        case 1:
          if (!(((_pendingSync = pendingSync) === null || _pendingSync === void 0 ? void 0 : _pendingSync.customerId) === customerId)) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return pendingSync.job;
        case 2:
          return _context2.a(2, _context2.v);
        case 3:
          job = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var _member$memberCode, member, memberCode, _pendingSync2, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  _context.p = 0;
                  _context.n = 1;
                  return requestMemberProfile({
                    customerId: customerId,
                    customerEmail: customerEmail
                  });
                case 1:
                  member = _context.v;
                  memberCode = String((_member$memberCode = member === null || member === void 0 ? void 0 : member.memberCode) !== null && _member$memberCode !== void 0 ? _member$memberCode : '').trim();
                  if (memberCode) {
                    storage(MEMBER_CODE_STORAGE_KEY).set({
                      customerId: customerId,
                      memberCode: memberCode
                    });
                  } else {
                    clearMemberCode();
                  }
                  return _context.a(2, memberCode);
                case 2:
                  _context.p = 2;
                  _t = _context.v;
                  console.warn('[member-code] request member profile failed', _t);
                  return _context.a(2, '');
                case 3:
                  _context.p = 3;
                  if (((_pendingSync2 = pendingSync) === null || _pendingSync2 === void 0 ? void 0 : _pendingSync2.job) === job) {
                    pendingSync = undefined;
                  }
                  return _context.f(3);
                case 4:
                  return _context.a(2);
              }
            }, _callee, null, [[0, 2, 3, 4]]);
          }))();
          pendingSync = {
            customerId: customerId,
            job: job
          };
          _context2.n = 4;
          return job;
        case 4:
          return _context2.a(2, _context2.v);
      }
    }, _callee2);
  }));
  return function syncMemberCode(_x) {
    return _ref5.apply(this, arguments);
  };
}()));

/**
 * 命中缓存直接返回；未登录清理缓存，已登录但无缓存时补拉接口并写入缓存
 *
 * 埋点上报前调用，保证 `member_code` 有值（接口失败时为空，不影响上报）。
 */
var ensureMemberCode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var _getLoginCustomerInfo2, customerID, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _getLoginCustomerInfo2 = getLoginCustomerInfo(), customerID = _getLoginCustomerInfo2.customerID;
          if (customerID) {
            _context3.n = 1;
            break;
          }
          clearMemberCode();
          return _context3.a(2, '');
        case 1:
          _t2 = getCachedMemberCode();
          if (_t2) {
            _context3.n = 3;
            break;
          }
          _context3.n = 2;
          return syncMemberCode();
        case 2:
          _t2 = _context3.v;
        case 3:
          return _context3.a(2, _t2);
      }
    }, _callee3);
  }));
  return function ensureMemberCode() {
    return _ref7.apply(this, arguments);
  };
}()));

/**
 * 登录 / 注册成功后调用（整页跳转前）
 *
 * 此时服务端还没渲染出 customer，拿不到 customerId，先打标记，回到落地页再补。
 */
var markMemberCodePending = function markMemberCodePending() {
  (0,_utils_storage__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(MEMBER_CODE_PENDING_STORAGE_KEY).set(true);
};

/**
 * 登录成功落地页初始化：写入会员编码缓存
 *
 * 只在登录跳转后的那次页面加载请求接口（标记一次性），避免每次页面加载都请求；
 * 后续埋点上报仍会通过 `ensureMemberCode` 兜底补拉。
 */
var syncMemberCodeAfterLogin = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          if (!(storage(MEMBER_CODE_PENDING_STORAGE_KEY).get() !== true)) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2, getCachedMemberCode());
        case 1:
          _context4.n = 2;
          return ensureMemberCode();
        case 2:
          return _context4.a(2, _context4.v);
      }
    }, _callee4);
  }));
  return function syncMemberCodeAfterLogin() {
    return _ref8.apply(this, arguments);
  };
}()));

/** 登出时清理会员编码缓存（含待补拉标记，避免下个账号复用） */
var clearMemberCode = function clearMemberCode() {
  storage(MEMBER_CODE_STORAGE_KEY).clear();
  storage(MEMBER_CODE_PENDING_STORAGE_KEY).clear();
};

/***/ }),

/***/ 36792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G6: function() { return /* binding */ isSafari; },
/* harmony export */   HI: function() { return /* binding */ encrypt; },
/* harmony export */   Jc: function() { return /* binding */ isInLuvmeApp; },
/* harmony export */   VF: function() { return /* binding */ detectDeviceType; },
/* harmony export */   jE: function() { return /* binding */ stripGid; },
/* harmony export */   oI: function() { return /* binding */ getMacCode; },
/* harmony export */   pO: function() { return /* binding */ parameter2Object; },
/* harmony export */   pe: function() { return /* binding */ decrypt; },
/* harmony export */   rS: function() { return /* binding */ base64UrlEncode; },
/* harmony export */   tq: function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports DEFAULT_START_YEAR, base64UrlDecode, encryptEmailForGa, getDateOptions, getvw2px, isDesktopDeviceWidth, isLuvmeApp, MONTH_OPTIONS, parameter, setLoginEmail, string2Dom, timeInterval, YEAR_OPTIONS */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84159);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48316);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35659);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44901);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89034);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96626);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92815);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14739);
/* harmony import */ var core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_constructor_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35172);
/* harmony import */ var core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21413);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_code_point_at_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(14579);
/* harmony import */ var core_js_modules_es_string_code_point_at_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_code_point_at_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30465);
/* harmony import */ var core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_from_code_point_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(86028);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(56836);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(64582);
/* harmony import */ var core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_copy_within_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(68645);
/* harmony import */ var core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_every_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(78886);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(55739);
/* harmony import */ var core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_filter_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(54626);
/* harmony import */ var core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(6949);
/* harmony import */ var core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_index_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(25978);
/* harmony import */ var core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_for_each_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(17374);
/* harmony import */ var core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_includes_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(52766);
/* harmony import */ var core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_index_of_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(60678);
/* harmony import */ var core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_iterator_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(41621);
/* harmony import */ var core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_join_js__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(64584);
/* harmony import */ var core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(49489);
/* harmony import */ var core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_map_js__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(79124);
/* harmony import */ var core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_js__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(92824);
/* harmony import */ var core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(99337);
/* harmony import */ var core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_reverse_js__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(24496);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(74899);
/* harmony import */ var core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_slice_js__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(95417);
/* harmony import */ var core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_some_js__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(11846);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(19293);
/* harmony import */ var core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_subarray_js__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(97236);
/* harmony import */ var core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_locale_string_js__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(51132);
/* harmony import */ var core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_string_js__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(26956);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(76679);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(77220);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(38440);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
























































var DEFAULT_START_YEAR = 1924;
var detectDeviceType = function detectDeviceType() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (/luvme/.test(userAgent)) {
    if (/android/.test(userAgent)) {
      return 'APP_ANDROID';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'APP_IOS';
    }
  } else if (/mobile/.test(userAgent)) {
    return 'SHOPIFY_M';
  } else {
    return 'SHOPIFY_PC';
  }
};
var isDesktopDeviceWidth = function isDesktopDeviceWidth() {
  return document.body.clientWidth > 768;
};
var isMobile = function (userAgent) {
  return !!/android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (fire)|silk|maemo|blackberry|playbook|bb10; (touch|kbd)|symbian(os)|ubuntu touch/i.test(userAgent);
}(navigator.userAgent);
var LUVME_APP_USER_AGENT_PATTERN = /reactnative\/luvme\/(?:ios|android)(?:\/|$)/i;
var isLuvmeApp = function isLuvmeApp() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  return LUVME_APP_USER_AGENT_PATTERN.test(userAgent);
};

/** 兼容现有业务直接读取布尔值的调用方式。 */
var isInLuvmeApp = isLuvmeApp();
var isSafari = function (userAgent) {
  return !!/^((?!chrome|android).)*safari/i.test(userAgent);
}(navigator.userAgent);
var getMacCode = function getMacCode() {
  var macCodeStorage = (0,_storage__WEBPACK_IMPORTED_MODULE_54__/* ["default"] */ .Z)('MAC_CODE');
  if (!macCodeStorage.get()) {
    macCodeStorage.set("".concat((0,uuid__WEBPACK_IMPORTED_MODULE_55__/* ["default"] */ .Z)(), "-").concat(Date.now()));
  }
  return macCodeStorage.get();
};
var decrypt = function decrypt(ciphertext, encryptionKey) {
  var key = crypto_js__WEBPACK_IMPORTED_MODULE_52___default().enc.Utf8.parse(encryptionKey);
  var bytes = crypto_js__WEBPACK_IMPORTED_MODULE_52___default().AES.decrypt(ciphertext, key, {
    mode: (crypto_js__WEBPACK_IMPORTED_MODULE_52___default().mode).ECB,
    padding: (crypto_js__WEBPACK_IMPORTED_MODULE_52___default().pad).Pkcs7
  });
  var decryptedData = crypto_js__WEBPACK_IMPORTED_MODULE_52___default().enc.Utf8.stringify(bytes).toString();
  return decryptedData;
};
var encrypt = function encrypt(data, decryptionKey) {
  var key = crypto_js__WEBPACK_IMPORTED_MODULE_52___default().enc.Utf8.parse(decryptionKey);
  var encryptedData = crypto_js__WEBPACK_IMPORTED_MODULE_52___default().AES.encrypt(data, key, {
    mode: (crypto_js__WEBPACK_IMPORTED_MODULE_52___default().mode).ECB,
    padding: (crypto_js__WEBPACK_IMPORTED_MODULE_52___default().pad).Pkcs7
  }).toString();
  return encryptedData;
};
var LOGIN_EMAIL_KEY = 'ABCD1234';

/** 缓存登录邮箱，空值时移除而非写入加密空串 */
var setLoginEmail = function setLoginEmail(email) {
  if (!email) {
    localStorage.removeItem('loginEmail');
    return;
  }
  localStorage.setItem('loginEmail', encrypt(email, LOGIN_EMAIL_KEY));
};

/** GA 上报用邮箱，空值返回 none 而非加密空串 */
var encryptEmailForGa = function encryptEmailForGa(email) {
  return email ? encrypt(email, LOGIN_EMAIL_KEY) : 'none';
};
var timeInterval = function timeInterval(onlineTime, offlineTime) {
  if (offlineTime) {
    // '2025/08/24---18:30:00-2025/08/24---19:30:00;2025/08/24---18:30:00-2025/08/24---19:30:00'
    var timeList = offlineTime.replaceAll('---', ' ').split(';').map(function (it) {
      var _it$split = it.split('-'),
        _it$split2 = _slicedToArray(_it$split, 2),
        startTime = _it$split2[0],
        endTime = _it$split2[1];
      var start = dayjs.tz(startTime, 'YYYY/MM/DD HH:mm:ss', 'Asia/Shanghai').unix();
      var end = dayjs.tz(endTime, 'YYYY/MM/DD HH:mm:ss', 'Asia/Shanghai').unix();
      return {
        start: start,
        end: end
      };
    });
    var now = dayjs().unix();
    var offline = timeList.find(function (it) {
      return now >= it.start && now <= it.end;
    });
    if (offline) return false;
  }
  if (!onlineTime) {
    return false;
  }
  var _onlineTime$split = onlineTime.split('-'),
    _onlineTime$split2 = _slicedToArray(_onlineTime$split, 2),
    startTime = _onlineTime$split2[0],
    endTime = _onlineTime$split2[1];
  if (!startTime || !endTime) return false;
  var currentTimeBeijing = dayjs(dayjs().tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'));
  var startTimeBeijing = dayjs("".concat(currentTimeBeijing.format('YYYY-MM-DD'), " ").concat(startTime));
  var endTimeBeijing = dayjs("".concat(currentTimeBeijing.format('YYYY-MM-DD'), " ").concat(endTime));
  var realEndTimeBeijing = startTimeBeijing.isAfter(endTimeBeijing) ? endTimeBeijing.add(1, 'day') : endTimeBeijing;
  if (currentTimeBeijing.isBetween(startTimeBeijing.format('YYYY-MM-DD HH:mm:ss'), realEndTimeBeijing.format('YYYY-MM-DD HH:mm:ss'))) {
    return true;
  }
  return false;
};
function parameter2Object(url) {
  var decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : decodeURIComponent;
  if (!url) {
    return {};
  }
  var search = url === null || url === void 0 ? void 0 : url.split('?')[1];
  if (!search) {
    return {};
  }
  return decode(search).replaceAll('"', '\\"').split('&').reduce(function (r, item) {
    var index = item.indexOf('=');
    if (!~index) {
      return r;
    }
    var key = item.slice(0, Math.max(0, index));
    var value = item.slice(Math.max(0, index + 1));
    r[key] = value;
    return r;
  }, {});
}
function cleanArray(actual) {
  var newArray = [];
  var _iterator = _createForOfIteratorHelper(actual),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      if (element) {
        newArray.push(element);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return newArray;
}
function parameter(json) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : encodeURIComponent;
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return "".concat(encode(key), "=").concat(encode(json[key]));
  })).join('&');
}
var YEAR_OPTIONS = function () {
  var startYear = DEFAULT_START_YEAR;
  var options = [];
  var currentYear = dayjs__WEBPACK_IMPORTED_MODULE_53___default()().year();
  while (startYear <= currentYear) {
    var format = "".concat(startYear);
    options.push({
      value: format,
      label: format
    });
    startYear++;
  }
  return options;
}();
var MONTH_OPTIONS = function () {
  var options = [];
  for (var _i = 0, _Object$entries = Object.entries(Array.from({
      length: 12
    }).fill('fragment')); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
      index = _Object$entries$_i[0];
    options.push({
      month: index,
      label: dayjs__WEBPACK_IMPORTED_MODULE_53___default()().set('month', index).format('MMM'),
      value: dayjs__WEBPACK_IMPORTED_MODULE_53___default()().set('month', index).format('MMM')
    });
  }
  return options;
}();
var getDateOptions = function getDateOptions(date) {
  var options = [];
  var formatDate = Number(date);
  for (var _i2 = 0, _Object$entries2 = Object.entries(Array.from({
      length: dayjs(formatDate).daysInMonth()
    })); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 1),
      index = _Object$entries2$_i[0];
    var current = dayjs(formatDate).set('date', Number(index) + 1).format('DD');
    options.push({
      label: current,
      value: current
    });
  }
  return options;
};
var string2Dom = function string2Dom(htmlString) {
  var container = document.createElement('div');
  container.innerHTML = htmlString;
  var fragment = document.createDocumentFragment();
  while (container.firstChild) {
    fragment.append(container.firstChild);
  }
  container.remove();
  return fragment;
};
function getvw2px(number) {
  return document.documentElement.clientWidth / 100 * (number / 7.5);
}

// 把字符串编码为 URL-safe Base64（无 padding）
function base64UrlEncode(string_) {
  // 把字符串转为 UTF-8 bytes
  var bytes = new TextEncoder().encode(string_);
  // 把 bytes 转为普通二进制字符串（每个字符一个字节）
  var binary = '';
  for (var index = 0; index < bytes.length; index++) binary += String.fromCodePoint(bytes[index]);
  // 标准 base64
  var base64 = btoa(binary);
  // 转为 url-safe 并去掉 padding
  return base64.replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '');
}

// 把 URL-safe Base64 解码回原始字符串（自动补齐 padding）
function base64UrlDecode(b64url) {
  // 恢复 '+' '/' 并补齐 padding
  var base64 = b64url.replaceAll('-', '+').replaceAll('_', '/');
  // 补齐到 4 的倍数
  while (base64.length % 4) base64 += '=';
  // base64 -> 二进制字符串
  var binary = atob(base64);
  // 二进制字符串 -> Uint8Array
  var bytes = new Uint8Array(binary.length);
  for (var index = 0; index < binary.length; index++) bytes[index] = binary.codePointAt(index);
  // UTF-8 解码回字符串
  return new TextDecoder().decode(bytes);
}

/** 去掉 Product / ProductVariant 的 GID 前缀，统一使用纯数字 ID */
function stripGid(id) {
  if (!id) return id;
  return String(id).replace(/^gid:\/\/shopify\/Product\//, '').replace(/^gid:\/\/shopify\/ProductVariant\//, '').replace(/^gid:\/\/shopify\/Customer\//, '');
}


/***/ }),

/***/ 39735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31955);












function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var DEFAULT_CONFIG = {
  attributes: true,
  // 监听属性变化
  childList: true,
  // 监听子节点变化
  subtree: true // 监听整个子树中的节点变化
};
var mutationObserver = function mutationObserver(target, callback, config) {
  var _config = config !== null && config !== void 0 ? config : DEFAULT_CONFIG;

  // 回调函数
  var _callback = lodash_es__WEBPACK_IMPORTED_MODULE_12__/* ["default"].debounce */ .ZP.debounce(function (mutationsList, observer) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        callback(mutation, observer);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, 33);

  // 创建一个新的 MutationObserver 实例
  var observer = new MutationObserver(_callback);

  // 开始观察目标节点
  observer.observe(target, _config);
  return observer;
};
/* harmony default export */ __webpack_exports__.Z = (mutationObserver);

/***/ }),

/***/ 69784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48914);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86225);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44567);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47134);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var number_precision__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17887);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

















var roundKeepZero = function roundKeepZero(number_) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var res = number_precision__WEBPACK_IMPORTED_MODULE_16__/* ["default"].round */ .ZP.round(number_, ratio);
  return res.toFixed(ratio);
};
/* harmony default export */ __webpack_exports__.Z = (_objectSpread(_objectSpread({}, number_precision__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP), {}, {
  roundKeepZero: roundKeepZero
}));

/***/ }),

/***/ 7448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ formatPrice; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48914);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86028);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26956);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64155);
/* harmony import */ var _type_check__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41130);









var formatPrice = function formatPrice(number_) {
  var bit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(number_, 'String') || (0,_type_check__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(number_, 'Number') ? (Math.round(+number_ * Math.pow(10, bit + 1) / 10) / Math.pow(10, bit)).toFixed(bit).toString().replaceAll(/\d(?=(?:\d{3})+\b)/g, '$&,') : number_;
};
window[_definitions__WEBPACK_IMPORTED_MODULE_8__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_8__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  formatPrice: formatPrice
});

/***/ }),

/***/ 24681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ rIC; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44901);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63402);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_1__);


// rIC.js
var rIC = function () {
  // 环境检测（非浏览器，如 Node/SSR）
  if (typeof window === 'undefined') {
    return function (callback) {
      callback({
        timeRemaining: function timeRemaining() {
          return 0;
        },
        didTimeout: true
      });
    };
  }
  var w = window;
  var nativeRIC = w.requestIdleCallback;
  var nativeCIC = w.cancelIdleCallback;
  var nativeWorks = false;
  if (typeof nativeRIC === 'function') {
    try {
      var testId = nativeRIC(function () {
        nativeWorks = true;
      });
      // 如果 50ms 内没有执行，则认为 native 失效
      setTimeout(function () {
        if (nativeCIC) nativeCIC(testId);
      }, 50);
    } catch (_unused) {
      nativeWorks = false;
    }
  }

  // 如果原生可用且能触发
  if (nativeWorks) {
    return function (callback, options) {
      return nativeRIC(callback, options);
    };
  }

  // fallback: 使用 MessageChannel，比 setTimeout 更稳
  var channel = new MessageChannel();
  var queue = [];
  channel.port1.onmessage = function () {
    var start = Date.now();
    var callback = queue.shift();
    if (callback) {
      callback({
        timeRemaining: function timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start));
        },
        didTimeout: false
      });
    }
  };
  return function (callback, options) {
    queue.push(callback);
    channel.port2.postMessage(null);
    if (options && typeof options.timeout === 'number') {
      setTimeout(function () {
        var index = queue.indexOf(callback);
        if (index !== -1) {
          queue.splice(index, 1);
          callback({
            timeRemaining: function timeRemaining() {
              return 0;
            },
            didTimeout: true
          });
        }
      }, options.timeout);
    }
  };
}();

/***/ }),

/***/ 19650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  QH: function() { return /* reexport */ base_axios_instance; },
  Pt: function() { return /* binding */ bytesServiceRequest; },
  xC: function() { return /* binding */ heteRequest; },
  Mz: function() { return /* binding */ storeFrontRequest; }
});

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(44901);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(19131);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(81970);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(62659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(3127);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ../node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(83067);
// EXTERNAL MODULE: ./definitions/index.js
var definitions = __webpack_require__(64155);
// EXTERNAL MODULE: ./utils/storage.js
var storage = __webpack_require__(38440);
;// CONCATENATED MODULE: ./utils/request/base-axios-instance.js



var instance = axios/* default */.Z.create({
  baseURL: '/',
  timeout: 20000,
  withCredentials: true
});
instance.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});
instance.interceptors.response.use(function (response) {
  var data = response.data;
  return data !== null && data !== void 0 ? data : {};
}, function (error) {
  // todo 此处需要弹窗提醒
  console.log(error);
  return undefined;
});
/* harmony default export */ var base_axios_instance = (instance);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2663);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(86225);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(44567);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(47134);
// EXTERNAL MODULE: ../node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(77220);
// EXTERNAL MODULE: ./utils/misc.js
var misc = __webpack_require__(36792);
;// CONCATENATED MODULE: ./utils/request/config-bytes-service.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }


















function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable unicorn/prevent-abbreviations */



var deviceType = (0,misc/* detectDeviceType */.VF)();
var headers = {
  'Content-Type': 'application/json'
};
var requestInterceptor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var config,
      baseData,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          if (config.data) {
            baseData = {
              version: 'v1',
              env: 'luvmehair',
              apikey: 'ccf2a9f5185c4f5bb3b2e16a0404010c',
              uid: localStorage.getItem('luvmehair/cly_cookie') || (0,v4/* default */.Z)(),
              platform: deviceType === 'SHOPIFY_PC' ? 'pc' : deviceType === 'SHOPIFY_M' ? 'm' : 'app'
            };
            config.data = JSON.stringify(_objectSpread(_objectSpread({}, baseData), config.data));
          }
          return _context.a(2, config);
      }
    }, _callee);
  }));
  return function requestInterceptor() {
    return _ref.apply(this, arguments);
  };
}();
var responseInterceptor = function responseInterceptor(res) {
  var _res$data = res.data,
    data = _res$data === void 0 ? {} : _res$data,
    status = res.status,
    statusText = res.statusText;
  if (status !== 200) return {
    message: statusText,
    code: status
  };
  return {
    code: 'SUCCESS',
    data: data
  };
};
/* harmony default export */ var config_bytes_service = ({
  baseURL: 'https://server002.recommend.bytem.com/',
  headers: headers,
  timeout: 10000,
  requestInterceptor: requestInterceptor,
  responseInterceptor: responseInterceptor
});
// EXTERNAL MODULE: ../node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__(92232);
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);
// EXTERNAL MODULE: ./utils/environment.js
var environment = __webpack_require__(75312);
;// CONCATENATED MODULE: ./utils/request/config-hete-service.js
function config_hete_service_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return config_hete_service_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (config_hete_service_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, config_hete_service_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, config_hete_service_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), config_hete_service_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", config_hete_service_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), config_hete_service_regeneratorDefine2(u), config_hete_service_regeneratorDefine2(u, o, "Generator"), config_hete_service_regeneratorDefine2(u, n, function () { return this; }), config_hete_service_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (config_hete_service_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function config_hete_service_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } config_hete_service_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { config_hete_service_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, config_hete_service_regeneratorDefine2(e, r, n, t); }
function config_hete_service_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function config_hete_service_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { config_hete_service_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { config_hete_service_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }







// https://q1my9tkfihy.feishu.cn/wiki/DLfYwq0m0ifWVOk7eBOcwtSmnkg?fromScene=spaceOverview




var heteApiConfig = {
  dev: {
    hostName: 'https://mall-gateway-dev.htwig.com',
    platCode: 'PC5',
    accountGroup: 'Uwins',
    platform: 'SHOPIFY',
    xHGateID: 'sdev01',
    xHGateSecret: 'cfuiewf23'
  },
  test: {
    hostName: 'https://mall-gateway-test.htwig.com',
    platCode: 'PC5',
    accountGroup: 'Uwins',
    platform: 'SHOPIFY',
    xHGateID: 'stest01',
    xHGateSecret: 'bywefc2'
  },
  sit: {
    hostName: 'https://mall-gateway-sit.htwig.com:30504',
    platCode: 'PC5',
    accountGroup: 'Uwins',
    platform: 'SHOPIFY',
    xHGateID: 'ssit01',
    xHGateSecret: 'cdbswvdcc23'
  },
  prod: {
    hostName: 'https://mall-gateway.htwig.com:31008',
    platCode: 'PC5',
    accountGroup: 'Uwins',
    platform: 'SHOPIFY',
    xHGateID: 's01',
    xHGateSecret: 's7VEoD8zKIyElN7d'
  }
};
var _getEnvironment = (0,environment/* getEnvironment */.z)(),
  siteEnv = _getEnvironment.siteEnv,
  nodeEnv = _getEnvironment.nodeEnv;
var shopifyEnvironment = nodeEnv === 'dev' ? 'prod' : siteEnv;
var heteConfig = heteApiConfig[shopifyEnvironment];
var platCode = heteConfig.platCode,
  accountGroup = heteConfig.accountGroup,
  platform = heteConfig.platform,
  hostName = heteConfig.hostName,
  xHGateID = heteConfig.xHGateID,
  xHGateSecret = heteConfig.xHGateSecret;
var getSourceType = function getSourceType() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (/luvme/.test(userAgent)) {
    if (/android/.test(userAgent)) {
      return 'ANDROID';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'IOS';
    }
  } else if (/mobile/.test(userAgent)) {
    return 'H5';
  } else {
    return 'PC';
  }
};
var config_hete_service_headers = {
  'Content-Type': 'application/json',
  'Hetectx-Plat-Code': platCode,
  'Hetectx-Account-Group': accountGroup,
  'Hetectx-Platform': platform,
  'Hetectx-Access-Channel': (0,misc/* detectDeviceType */.VF)(),
  'X-HGate-Id': xHGateID,
  'Hetectx-Source-Type': getSourceType()
};
var config_hete_service_requestInterceptor = /*#__PURE__*/function () {
  var _ref = config_hete_service_asyncToGenerator(/*#__PURE__*/config_hete_service_regenerator().m(function _callee() {
    var config,
      signature,
      _args = arguments;
    return config_hete_service_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          // SHA256(id + secret + path + body)
          signature = sha256_default()(xHGateID + xHGateSecret + config.url + JSON.stringify(config.data));
          config.headers['X-HGate-Sign'] = signature;
          return _context.a(2, config);
      }
    }, _callee);
  }));
  return function requestInterceptor() {
    return _ref.apply(this, arguments);
  };
}();
var config_hete_service_responseInterceptor = function responseInterceptor(result) {
  var _result$data = result.data,
    data = _result$data === void 0 ? {} : _result$data,
    headers = result.headers,
    status = result.status,
    statusText = result.statusText;
  if (status !== 200) {
    return {
      message: statusText,
      code: status
    };
  }
  var code = data.code,
    message = data.message;
  if (code !== 'SUCCESS') {
    return {
      code: code,
      message: message,
      traceId: headers['trace-id']
    };
  }
  return data;
};
/* harmony default export */ var config_hete_service = ({
  baseURL: hostName,
  headers: config_hete_service_headers,
  timeout: 10000,
  requestInterceptor: config_hete_service_requestInterceptor,
  responseInterceptor: config_hete_service_responseInterceptor,
  heteConfig: heteConfig
});
;// CONCATENATED MODULE: ./utils/request/config-store-front-service.js






function config_store_front_service_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return config_store_front_service_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (config_store_front_service_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, config_store_front_service_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, config_store_front_service_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), config_store_front_service_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", config_store_front_service_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), config_store_front_service_regeneratorDefine2(u), config_store_front_service_regeneratorDefine2(u, o, "Generator"), config_store_front_service_regeneratorDefine2(u, n, function () { return this; }), config_store_front_service_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (config_store_front_service_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function config_store_front_service_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } config_store_front_service_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { config_store_front_service_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, config_store_front_service_regeneratorDefine2(e, r, n, t); }
function config_store_front_service_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function config_store_front_service_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { config_store_front_service_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { config_store_front_service_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable unicorn/prevent-abbreviations */

var config_store_front_service_headers = {
  'Content-Type': 'application/json',
  'X-Shopify-Storefront-Access-Token': '67911f3e5eafcf4a3192e2e8ffb3fa56'
};
var config_store_front_service_requestInterceptor = /*#__PURE__*/function () {
  var _ref = config_store_front_service_asyncToGenerator(/*#__PURE__*/config_store_front_service_regenerator().m(function _callee() {
    var config,
      _args = arguments;
    return config_store_front_service_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          if (config.data) {
            config.data = JSON.stringify(config.data);
          }
          return _context.a(2, config);
      }
    }, _callee);
  }));
  return function requestInterceptor() {
    return _ref.apply(this, arguments);
  };
}();
var config_store_front_service_responseInterceptor = function responseInterceptor(res) {
  var _res$data = res.data,
    data = _res$data === void 0 ? {} : _res$data,
    status = res.status,
    statusText = res.statusText;
  if (status !== 200) return {
    message: statusText,
    code: status
  };
  var dataRes = data.data,
    errors = data.errors;
  return dataRes ? {
    code: 'SUCCESS',
    data: dataRes
  } : {
    code: 'ERROR',
    errors: errors
  };
};
/* harmony default export */ var config_store_front_service = ({
  headers: config_store_front_service_headers,
  timeout: 10000,
  requestInterceptor: config_store_front_service_requestInterceptor,
  responseInterceptor: config_store_front_service_responseInterceptor
});
;// CONCATENATED MODULE: ./utils/request/index.js
var _excluded = ["requestInterceptor", "responseInterceptor"],
  _excluded2 = ["retry"],
  _excluded3 = ["maxAge", "data"],
  _excluded4 = ["data"];
function request_defineProperty(e, r, t) { return (r = request_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function request_typeof(o) { "@babel/helpers - typeof"; return request_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, request_typeof(o); }
























function request_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return request_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (request_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, request_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, request_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), request_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", request_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), request_regeneratorDefine2(u), request_regeneratorDefine2(u, o, "Generator"), request_regeneratorDefine2(u, n, function () { return this; }), request_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (request_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function request_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } request_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { request_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, request_regeneratorDefine2(e, r, n, t); }
function request_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function request_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { request_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { request_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, request_toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function request_toPropertyKey(t) { var i = request_toPrimitive(t, "string"); return "symbol" == request_typeof(i) ? i : i + ""; }
function request_toPrimitive(t, r) { if ("object" != request_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != request_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var API_CACHE_KEY = 'API_CACHE';
var API_CACHE_VERSION = '1.0.0';
var Request = /*#__PURE__*/function () {
  function Request() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Request);
    var requestInterceptor = config.requestInterceptor,
      responseInterceptor = config.responseInterceptor,
      other = _objectWithoutProperties(config, _excluded);
    this.instance = axios/* default */.Z.create(other);
    requestInterceptor && this.instance.interceptors.request.use(requestInterceptor);
    responseInterceptor && this.instance.interceptors.response.use(responseInterceptor);
  }
  return _createClass(Request, [{
    key: "postData",
    value: function () {
      var _postData = request_asyncToGenerator(/*#__PURE__*/request_regenerator().m(function _callee(url, data) {
        var config,
          retryTimes,
          result,
          _args = arguments;
        return request_regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              retryTimes = _args.length > 3 ? _args[3] : undefined;
              _context.n = 1;
              return this.instance.post(url, data, config);
            case 1:
              result = _context.v;
              if (!(result.code === 'SUCCESS')) {
                _context.n = 2;
                break;
              }
              return _context.a(2, result);
            case 2:
              if (!(retryTimes === 0)) {
                _context.n = 3;
                break;
              }
              return _context.a(2, result);
            case 3:
              retryTimes--;
              return _context.a(2, this.postData(url, data, config, retryTimes));
          }
        }, _callee, this);
      }));
      function postData(_x, _x2) {
        return _postData.apply(this, arguments);
      }
      return postData;
    }()
  }, {
    key: "postDataWithRetry",
    value: function postDataWithRetry(url, data) {
      var _this = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _config$retry = config.retry,
        retry = _config$retry === void 0 ? true : _config$retry,
        other = _objectWithoutProperties(config, _excluded2);
      var retryTimes = retry ? 3 : 0;
      return new Promise(/*#__PURE__*/function () {
        var _ref = request_asyncToGenerator(/*#__PURE__*/request_regenerator().m(function _callee2(resolve, reject) {
          var result, _t;
          return request_regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                _context2.p = 0;
                _context2.n = 1;
                return _this.postData(url, data, other, retryTimes);
              case 1:
                result = _context2.v;
                if (!(result.code === 'SUCCESS')) {
                  _context2.n = 2;
                  break;
                }
                return _context2.a(2, resolve(result.data));
              case 2:
                return _context2.a(2, reject(result));
              case 3:
                _context2.p = 3;
                _t = _context2.v;
                reject(_t);
              case 4:
                return _context2.a(2);
            }
          }, _callee2, null, [[0, 3]]);
        }));
        return function (_x3, _x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);
}();
var getCacheKey = function getCacheKey() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cacheKey = url;
  var keys = Object.keys(parameters).sort();
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      cacheKey = "".concat(cacheKey, "/").concat(key, "=").concat(parameters[key]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cacheKey;
};

// hete请求
var heteService = new Request(config_hete_service);
var pendingCacheableRequests = new Map();
var heteRequest = /*#__PURE__*/function () {
  var _ref2 = request_asyncToGenerator(/*#__PURE__*/request_regenerator().m(function _callee3(url) {
    var config,
      maxAge,
      data,
      other,
      cacheKey,
      _storage$get,
      _cacheData$cacheKey,
      _ref3,
      _ref3$data,
      cacheData,
      _ref4,
      expireTime,
      value,
      resultJob,
      result,
      _storage$get$data,
      _storage$get2,
      _expireTime,
      _args3 = arguments;
    return request_regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          config = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          maxAge = config.maxAge, data = config.data, other = _objectWithoutProperties(config, _excluded3);
          cacheKey = getCacheKey(url, data);
          if (!maxAge) {
            _context3.n = 5;
            break;
          }
          _ref3 = (_storage$get = (0,storage/* default */.Z)(API_CACHE_KEY).get()) !== null && _storage$get !== void 0 ? _storage$get : {}, _ref3$data = _ref3.data, cacheData = _ref3$data === void 0 ? {} : _ref3$data;
          _ref4 = (_cacheData$cacheKey = cacheData[cacheKey]) !== null && _cacheData$cacheKey !== void 0 ? _cacheData$cacheKey : {}, expireTime = _ref4.expireTime, value = _ref4.value;
          if (!expireTime) {
            _context3.n = 3;
            break;
          }
          if (!(Date.now() <= expireTime)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, value);
        case 1:
          delete cacheData[cacheKey];
          (0,storage/* default */.Z)(API_CACHE_KEY).set({
            version: API_CACHE_VERSION,
            data: cacheData
          });
        case 2:
          _context3.n = 5;
          break;
        case 3:
          if (!pendingCacheableRequests.has(cacheKey)) {
            _context3.n = 5;
            break;
          }
          _context3.n = 4;
          return pendingCacheableRequests.get(cacheKey);
        case 4:
          return _context3.a(2, _context3.v);
        case 5:
          resultJob = heteService.postDataWithRetry(url, data, other);
          if (maxAge) pendingCacheableRequests.set(cacheKey, resultJob);
          _context3.n = 6;
          return resultJob;
        case 6:
          result = _context3.v;
          if (maxAge) {
            _expireTime = Date.now() + maxAge;
            (0,storage/* default */.Z)(API_CACHE_KEY).set({
              version: API_CACHE_VERSION,
              data: Object.assign({}, (_storage$get$data = (_storage$get2 = (0,storage/* default */.Z)(API_CACHE_KEY).get()) === null || _storage$get2 === void 0 ? void 0 : _storage$get2.data) !== null && _storage$get$data !== void 0 ? _storage$get$data : {}, request_defineProperty({}, cacheKey, {
                expireTime: _expireTime,
                value: result
              }))
            });
            pendingCacheableRequests.delete(cacheKey);
          }
          return _context3.a(2, result);
      }
    }, _callee3);
  }));
  return function heteRequest(_x5) {
    return _ref2.apply(this, arguments);
  };
}();

// store front 请求
var storeFrontService = new Request(config_store_front_service);
var storeFrontRequest = /*#__PURE__*/function () {
  var _ref5 = request_asyncToGenerator(/*#__PURE__*/request_regenerator().m(function _callee4(query, variables, config) {
    var apiVersion;
    return request_regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          apiVersion = (config === null || config === void 0 ? void 0 : config.apiVersion) || '2023-04';
          return _context4.a(2, storeFrontService.postDataWithRetry("https://za.luvmehair.com/api/".concat(apiVersion, "/graphql.json"), {
            query: query,
            variables: variables
          }, config));
      }
    }, _callee4);
  }));
  return function storeFrontRequest(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

// 字节元请求
var bytesServiceService = new Request(config_bytes_service);
var bytesServiceRequest = /*#__PURE__*/function () {
  var _ref6 = request_asyncToGenerator(/*#__PURE__*/request_regenerator().m(function _callee5(url) {
    var config,
      data,
      other,
      _args5 = arguments;
    return request_regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          config = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          data = config.data, other = _objectWithoutProperties(config, _excluded4);
          return _context5.a(2, bytesServiceService.postDataWithRetry(url, data, other));
      }
    }, _callee5);
  }));
  return function bytesServiceRequest(_x9) {
    return _ref6.apply(this, arguments);
  };
}();
window[definitions/* MISCELLANY_PREFIX */.x7] = Object.assign({}, window[definitions/* MISCELLANY_PREFIX */.x7] || {}, {
  heteRequest: heteRequest,
  storeFrontRequest: storeFrontRequest,
  bytesServiceRequest: bytesServiceRequest
});


/***/ }),

/***/ 38440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);

var storage = function storage(key) {
  var keepOnWindowClosed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var target = (keepOnWindowClosed !== null && keepOnWindowClosed !== void 0 ? keepOnWindowClosed : false) ? localStorage : sessionStorage;
  var get = function get() {
    try {
      return JSON.parse(target.getItem(key)) || target.getItem(key) || undefined;
    } catch (_unused) {
      return target.getItem(key) || undefined;
    }
  };

  /**
   * 此处需对 set 做批量处理
   * @param {*} parameters
   */
  var set = function set(parameters) {
    try {
      target.setItem(key, JSON.stringify(parameters));
    } catch (_unused2) {
      target.setItem(key, parameters);
    }
  };
  var clear = function clear() {
    target.removeItem(key);
  };
  return {
    get: get,
    set: set,
    clear: clear
  };
};
/* harmony default export */ __webpack_exports__.Z = (storage);

/***/ }),

/***/ 45837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91270);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88646);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48949);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62659);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21413);
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59139);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5188);
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(64155);
/* harmony import */ var _event_emitter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81228);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38440);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


















function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var Store = /*#__PURE__*/function () {
  function Store() {
    _classCallCheck(this, Store);
    this._eventName = 'DATA_STORE';
    this._state = Object.create(null);

    // 预设值
    this.setState(function (draft) {
      for (var _i = 0, _Object$entries = Object.entries((_window$MISCELLANY_PR = (_window = window) === null || _window === void 0 || (_window = _window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7]) === null || _window === void 0 ? void 0 : _window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .DEFAULT_STORE_STATE */ .Mx]) !== null && _window$MISCELLANY_PR !== void 0 ? _window$MISCELLANY_PR : Object.create(null)); _i < _Object$entries.length; _i++) {
        var _window$MISCELLANY_PR, _window;
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        draft[key] = value;
      }
    });
  }

  /**
   *
   * @param {*} key
   * @param {*} resetByDefaultStoreState 当js非直接调用，比如弹窗渲染，可重置
   * @returns
   */
  return _createClass(Store, [{
    key: "getState",
    value: function getState(key) {
      var resetByDefaultStoreState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (resetByDefaultStoreState) {
        this.setState(function (draft) {
          var _window2;
          draft[key] = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7]) === null || _window2 === void 0 || (_window2 = _window2[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .DEFAULT_STORE_STATE */ .Mx]) === null || _window2 === void 0 ? void 0 : _window2[key];
        });
      }
      return key ? this._state[key] : this._state;
    }

    /**
     * @param {*} data 变更函数
     * @param {*} isStorage 浏览器缓存
     * @param {*} isDispatch 是否执行 _dispatch
     */
  }, {
    key: "setState",
    value: function setState(updater, isStorage, isDispatch) {
      this._state = (0,immer__WEBPACK_IMPORTED_MODULE_21__/* .produce */ .Uy)(this._state, updater);
      if (isStorage) {
        (0,_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(this._eventName).set(this._state);
      }
      if (isDispatch) {
        this._dispatch();
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this._state = Object.create(null);
    }

    /**
     * @param {*} callback
     * @param {*} autoTrigger 在初次绑定监听函数时如果有缓存数据，是否需要主动触发一次，默认为false
     */
  }, {
    key: "addDataListener",
    value: function addDataListener(callback, autoTrigger) {
      _event_emitter__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z.addListener(this._eventName, callback);
      if (!autoTrigger || Object.keys(this._state).length === 0) {
        return;
      }
      this._dispatch();
    }
  }, {
    key: "removeDataListener",
    value: function removeDataListener() {
      _event_emitter__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z.removeListener(this._eventName);
    }
  }, {
    key: "_dispatch",
    value: function _dispatch() {
      _event_emitter__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z.emit(this._eventName, this._state);
    }
  }]);
}();
var store = new Store();
window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7] = Object.assign({}, window[_definitions__WEBPACK_IMPORTED_MODULE_20__/* .MISCELLANY_PREFIX */ .x7] || {}, {
  store: store
});
/* harmony default export */ __webpack_exports__.Z = (store);

/***/ }),

/***/ 41130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54134);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__);


var typeCheck = function typeCheck(data, type) {
  if (!type) {
    return Object.prototype.toString.call(data);
  }
  return Object.prototype.toString.call(data) === "[object ".concat(type, "]");
};
/* harmony default export */ __webpack_exports__.Z = (typeCheck);

/***/ }),

/***/ 50283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hh: function() { return /* binding */ filterProductGiveawayResult; },
/* harmony export */   ky: function() { return /* binding */ filterOrderGiveawayResult; }
/* harmony export */ });
/* unused harmony exports GIFT_VISIBLE_REGION, isGiftVisibleForRegion */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56187);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38690);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89228);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26031);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2663);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66066);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13227);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95822);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11908);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86225);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44567);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3127);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81414);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33370);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14011);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47134);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11431);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

















var GIFT_VISIBLE_REGION = {
  US: 'US',
  NON_US: 'NON_US'
};

/**
 * 与 Luvme 一致的活动可见地区判断
 * - 活动未配置可见地区：不限地区
 * - 拿不到 IP 信息：放行，避免误伤
 * - 美区 IP：需要包含 US
 * - 非美区 IP：需要包含 NON_US
 */
var isGiftVisibleForRegion = function isGiftVisibleForRegion(visibleRegion, isUsIp) {
  if (!(visibleRegion !== null && visibleRegion !== void 0 && visibleRegion.length) || isUsIp === undefined) {
    return true;
  }
  return isUsIp ? visibleRegion.includes(GIFT_VISIBLE_REGION.US) : visibleRegion.includes(GIFT_VISIBLE_REGION.NON_US);
};
var filterProductGiveawayResult = function filterProductGiveawayResult(data, isUsIp) {
  var _data$list;
  if (!(data !== null && data !== void 0 && (_data$list = data.list) !== null && _data$list !== void 0 && _data$list.length)) {
    return data !== null && data !== void 0 ? data : null;
  }
  var list = data.list.filter(function (item) {
    return isGiftVisibleForRegion(item.visibleRegion, isUsIp);
  });
  return list.length > 0 ? _objectSpread(_objectSpread({}, data), {}, {
    list: list
  }) : null;
};
var filterOrderGiveawayResult = function filterOrderGiveawayResult(data, isUsIp) {
  if (!data) {
    return null;
  }
  return isGiftVisibleForRegion(data.visibleRegion, isUsIp) ? data : null;
};

/***/ })

}]);